import React, { forwardRef, useEffect, useState } from "react";
import LoanReturnsGrid from "./LoanReturnsGrid";
import _ from "lodash";
import {
  getAllocations,
  getLoanReturns,
  getReturnsByContract,
  isServiceHealthy,
} from "../../utils/API";
import { useNavigate } from "react-router";
import withUser from "../../redux/HOC/withUser";
import {
  debounceGlobalSearch,
  getTimeStamp,
} from "../../common/commonFunctions";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import SearchIcon from "@mui/icons-material/Search";
import excel from "../../assets/images/excel.svg";
import RefreshIcon from "@mui/icons-material/Refresh";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import moment from "moment";
import {
  constants,
  EndPoint,
  messages,
  metricFilters,
  socketMsgType,
} from "../../common/constants";
import AllocationsGrid from "./AllocationsGrid";
import SockJS from "sockjs-client";
import {
  BASE_URI_SOCKET,
  envs,
  getEnv,
  serviceAPIMapping,
} from "../../config/service-api-mapping";
import { Stomp } from "@stomp/stompjs";
import { Split } from "@geoffcox/react-splitter";
import "../../common/style.css";
import "./style.css";
import KPIComponent from "../../components/KPIComponent";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { Modal } from "react-bootstrap";
import ContractReturn from "../../components/ContractReturn";
import { Card, CardContent } from "@mui/material";

const LoanReturns = (props: any) => {
  const [lastRefresh, setLastRefresh] = useState<any>("");
  //const dtcSocket = new SockJS(`${BASE_URI_DTC_SOCKET()}`);
  const [loanReturns, setLoanReturns] = useState<any[]>([]);
  const [initialLoanReturns, setInitialLoanReturns] = useState<any[]>([]);
  const [allocations, setAllocations] = useState<any[]>([]);
  const [initialAllocations, setInitialAllocations] = useState<any[]>([]);
  const [selectedCusip, setSelectedCusip] = useState<any>(null);
  const [selectedTicker, setSelectedTicker] = useState<any>(null);
  const [selectedTickerCusip, setSelectedTickerCusip] = useState<any>(null);
  const [isAllocationsProcessing, setIsAllocationsProcessing] =
    useState<boolean>(false);
  const [isCallbacksProcessing, setIsCallbacksProcessing] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const [globalSearch, setGlobalSearch] = useState<string>("");
  const [accountId, setAccountId] = useState<any>(null);
  const [refLoanReturns, setRefLoanReturns] = useState<any>(null);
  const [refAllocations, setRefAllocations] = useState<any>(null);
  // const dtcStompClient = Stomp.over(function () {
  //   return dtcSocket;
  // });
  const [appliedFiltersAllocGrid, setAppliedFiltersAllocGrid] =
    useState<any>(null);
  const [isGridRefresh, setIsGridRefresh] = useState<Boolean>(false);
  const [appliedFiltersCallbackGrid, setAppliedFiltersCallbackGrid] =
    useState<any>(null);
  // const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const [isTotalRowToBeSelected, setIsTotalRowToBeSelected] =
    useState<boolean>(false);
  const [loanSettledCount, setLoanSettledCount] = useState<number>(0);
  const [buyInCount, setBuyInCount] = useState<number>(0);
  const [loanUnsettledCount, setLoanUnsettledCount] = useState<number>(0);
  const [settledCount, setSettledCount] = useState<number>(0);
  const [unsettledCount, setUnsettledCount] = useState<number>(0);
  const [loanAllocatedCount, setLoanAllocatedCount] = useState<number>(0);
  const [loanUnallocatedCount, setLoanUnallocatedCount] = useState<number>(0);
  const [fullyReturnedCount, setFullyReturnedCount] = useState<number>(0);
  const [isResetFilters, setIsResetFilters] = useState<boolean>(false);
  const [extneralCallbackFilters, setExtneralCallbackFilters] =
    useState<any>(null);
  const [extneralAllocationFilters, setExtneralAlocationFilters] =
    useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [isDeselectAll, setIsDeselectAll] = useState<boolean>(false);

  const [allocatedCount, setAllocatedCount] = useState<number>(0);
  const [unallocatedCount, setUnallocatedCount] = useState<number>(0);

  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [rowsToReturn, setRowsToReturn] = useState<any>([]);
  const [isContractReturnPopupOpen, setContractReturnPopupOpen] =
    useState<boolean>(false);
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
    useState<boolean>(false);
  const socketConsolidate = new SockJS(`${BASE_URI_SOCKET()}`);
  const socketConsolidateClient = Stomp.over(function () {
    return socketConsolidate;
  });
  const [insertedLoanReturnRowIds, setInsertedLoanReturnRowIds] = useState<any>(
    []
  );
  const [insertedLoanReturnRows, setInsertedLoanReturnRows] = useState<any>([]);
  const [insertedAllocationRows, setInsertedAllocationRows] = useState<any>([]);
  const [insertedAllocationRowIds, setInsertedAllocationRowIds] = useState<any>(
    []
  );

  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  useEffect(() => {
    let activeAccountCode = window.localStorage.getItem("activeAccountCode");
    if (activeAccountCode) {
      setAccountId(activeAccountCode);
    }
  }, []);

  useEffect(() => {
    if (loanReturns && !_.isEmpty(loanReturns) && isTotalRowToBeSelected) {
      // setIsDataLoaded(!isDataLoaded);
      setIsTotalRowToBeSelected(false);
    }
  }, [loanReturns]);

  const getTotalReturnQuantity = (cusip: any, allocationList: any) => {
    let cusipRows = allocationList.filter(
      (a: any) => a.sec_id === cusip && a.isAllocated === "Y"
    );
    let sum = _.sumBy(cusipRows, "return_quantity");

    return sum;
  };

  useEffect(() => {
    if (
      !_.isEmpty(loanReturns) &&
      !_.isEmpty(initialAllocations) &&
      !_.isNull(selectedCusip)
    ) {
      setLoanReturns((previousRows: any) => {
        if (_.isArray(previousRows)) {
          let currentRows = [...previousRows];
          currentRows.map((r: any) => {
            if (r.cusip === selectedCusip) {
              r = {
                ...r,
                totalReturnQuantity: getTotalReturnQuantity(
                  r.cusip,
                  initialAllocations
                ),
                allocationPercentage: getAllocationPercentage(
                  r.cusip,
                  initialAllocations,
                  r.callback_quantity
                ),
                cusipBasedAllocationPercentage: getCusipAllocationPercentage(
                  r.cusip,
                  initialAllocations,
                  initialLoanReturns
                ),
              };
            }
          });

          return currentRows;
        }
        return previousRows;
      });
      setInitialLoanReturns((previousRows: any) => {
        if (_.isArray(previousRows)) {
          let currentRows = [...previousRows];
          currentRows.map((r: any) => {
            if (r.cusip === selectedCusip) {
              r = {
                ...r,
                totalReturnQuantity: getTotalReturnQuantity(
                  r.cusip,
                  initialAllocations
                ),
                allocationPercentage: getAllocationPercentage(
                  r.cusip,
                  initialAllocations,
                  r.callback_quantity
                ),
                cusipBasedAllocationPercentage: getCusipAllocationPercentage(
                  r.cusip,
                  initialAllocations,
                  initialLoanReturns
                ),
              };
            }
          });

          return currentRows;
        }
        return previousRows;
      });
    }
  }, [initialAllocations]);

  useEffect(() => {
    calculateLoanCounts(initialLoanReturns);
  }, [initialLoanReturns]);

  useEffect(() => {
    calculateAllocationCounts(initialAllocations);
  }, [initialAllocations]);

  const getAllocationPercentage = (
    cusip: any,
    allocationList: any,
    total: any
  ) => {
    let cusipRows = allocationList.filter(
      (a: any) => a.sec_id === cusip && a.isAllocated === "Y"
    );
    let sum = _.sumBy(cusipRows, "return_quantity");

    return Math.round((sum / total) * 100);
  };

  const getCusipAllocationPercentage = (
    cusip: any,
    allocationList: any,
    callbackRows: any
  ) => {
    let cusipRows = allocationList.filter(
      (a: any) => a.sec_id === cusip && a.isAllocated === "Y"
    );
    let sum = _.sumBy(cusipRows, "return_quantity");
    let cusipCallbacks = callbackRows.filter((a: any) => a.cusip === cusip);
    let total = _.sumBy(cusipCallbacks, "callback_quantity");
    return Math.round((sum / total) * 100);
  };

  const getLoanReturnsList = async (accId: any) => {
    setIsCallbacksProcessing(true);
    let loanReturnsRes: any = "";
    let accessToken = window.localStorage.getItem("refreshtoken");
    let accountId = window.localStorage.getItem("activeAccountCode");
    try {
      loanReturnsRes = await getLoanReturns(
        accId,
        props.user.tokenType,
        accessToken
      );
      if (!loanReturnsRes) {
        setOpen(true);
        setSnackbarMessage(messages.returnsServiceDown);
      } else if (loanReturnsRes?.status === 200) {
        setIsTotalRowToBeSelected(true);
        const loansResult = await loanReturnsRes.json();
        const totalAllocations = await getAllocationsList(accountId, null);
        if (_.isArray(totalAllocations)) {
          let selectedAllocationList = [...totalAllocations];
          setSelectedCusip((prevVal: any) => {
            if (prevVal) {
              selectedAllocationList = totalAllocations.filter(
                (a: any) => a.sec_id === prevVal
              );
            }
            setInitialAllocations([...selectedAllocationList]);
            return prevVal;
          });
        }
        if (loansResult?.length > 0) {
          let rows = loansResult.map((r: any) => ({
            ...r,
            createdDate: getTimeStamp(r.create_date),
            totalReturnQuantity: getTotalReturnQuantity(
              r.cusip,
              totalAllocations
            ),
            callbackCreatedDate: getTimeStamp(r.callback_create_date),
            callbackUpdatedDate: getTimeStamp(r.callback_updated_date),
            returnUpdatedDate: getTimeStamp(r.return_updated_date),
            allocationPercentage: getAllocationPercentage(
              r.cusip,
              totalAllocations,
              r.callback_quantity
            ),
            cusipBasedAllocationPercentage: getCusipAllocationPercentage(
              r.cusip,
              totalAllocations,
              loansResult
            ),
          }));

          setInitialLoanReturns([...rows]);
        }
      } else if (loanReturnsRes?.status === 401) {
        navigate("/signin");
      } else {
        setLoanReturns([]);
        setInitialLoanReturns([]);
        setInitialAllocations([]);
        setAllocations([]);
      }
    } catch (err) {
      setLoanReturns([]);
      setInitialLoanReturns([]);
      setInitialAllocations([]);
      setAllocations([]);
    } finally {
      setTimeout(() => {
        setIsCallbacksProcessing(false);
        setIsGridRefresh(!isGridRefresh);
      }, 200);
    }
  };

  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      refLoanReturns?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Loan Callbacks",
      })!,
      refAllocations?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Borrow Allocations",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "callbacks.xlsx",
    });
  }

  const refreshDate = () => {
    setLastRefresh(moment(new Date()).format(constants.RefreshFormat));
  };

  const refreshAccount = () => {
    let accountId = window.localStorage.getItem("activeAccountCode");
    // setIsCallbacksProcessing(true);
    getLoanReturnsList(accountId);
    refreshDate();
    setIsDeselectAll(false);
  };

  const refreshAccountObj = () => {
    let accountId = window.localStorage.getItem("activeAccountCode");
    setIsAllocationsProcessing(true);
    setLoanReturns([]);
    setInitialLoanReturns([]);
    setInitialAllocations([]);
    setAllocations([]);
    getLoanReturnsList(accountId);
    refreshDate();
    setIsDeselectAll(false);
  };

  const onFilterTextChange = (event: any) => {
    debounceGlobalSearch(event.target.value, setGlobalSearch);
  };

  const getAllocationsList = async (accId: any, cusip: any) => {
    let allocationsRes: any = "";
    let accessToken = window.localStorage.getItem("refreshtoken");
    try {
      allocationsRes = await getAllocations(
        accId,
        props.user.tokenType,
        accessToken,
        cusip
      );
      if (!allocationsRes) {
        setOpen(true);
        setSnackbarMessage(messages.returnsServiceDown);
      } else if (allocationsRes?.status === 200) {
        const allocationsResult = await allocationsRes.json();
        if (allocationsResult?.length > 0) {
          let rows = allocationsResult.map((r: any) => ({
            ...r,
            id: r.returns_id > 0 ? r.returns_id : r.contract_id,
            // id:
            //   (r.contract_id ? r.contract_id.toString() : "") +
            //   (r.bl ? r.bl : "") +
            //   (r.returns_id ? r.returns_id.toString() : ""),

            isBuyIn: r.is_buyin === null ? "null" : r.is_buyin,
            returnUpdatedDate: getTimeStamp(r.return_updated_date),
          }));
          const groupedRows = _.groupBy(rows, "contract_id");
          const finalList: any[] = [];
          _.forIn(groupedRows, (value: any, key: any) => {
            if (_.isArray(value) && value?.length > 0) {
              // const allocatedList = value?.filter((x:any)=> x.isAllocated === 'Y')
              // const returnedQuantity = _.sumBy(allocatedList, "return_quantity");
              const borrow_quantity = value[0]?.borrow_quantity;
              const list = value?.map((contract: any) => {
                return {
                  ...contract,
                  isFullyReturned: borrow_quantity === 0,
                };
              });

              if (_.isArray(list) && list?.length > 0) {
                finalList.push(...list);
              }
            }
          });

          return finalList;
        } else {
          return [];
        }
      } else if (allocationsRes?.status === 401) {
        setIsAllocationsProcessing(false);
        navigate("/signin");
      } else {
        return [];
      }
    } catch (err) {
      return [];
    } finally {
      setIsAllocationsProcessing(false);
    }
  };

  const reset = () => {
    setIsAllocationsProcessing(true);
    setIsResetFilters(!isResetFilters);
    setSelectedTicker(null);
    setSelectedTickerCusip(null);
    _.isNull(selectedCusip)
      ? setCusipAllocations(null)
      : setSelectedCusip(null);
    setSelectedRows([]);
  };

  const calculateLoanCounts = (rows: any) => {
    let loanSettledRows = rows?.filter(
      (x: any) => x.return_dtc_status === "Settled"
    );
    setLoanSettledCount(loanSettledRows?.length);
    let loanUnsettledRows = rows?.filter(
      (x: any) =>
        x.cusipBasedAllocationPercentage >= 100 &&
        x.return_dtc_status !== "Settled"
    );
    setLoanUnsettledCount(loanUnsettledRows?.length);
    let allocatedRows = rows?.filter(
      (x: any) => x.cusipBasedAllocationPercentage >= 100
    );
    setLoanAllocatedCount(allocatedRows?.length);
    let unallocatedRows = rows?.filter(
      (x: any) => x.cusipBasedAllocationPercentage < 100
    );
    setLoanUnallocatedCount(unallocatedRows?.length);
  };

  const calculateAllocationCounts = (rows: any) => {
    let allocatedRows = rows?.filter((x: any) => x.isAllocated === "Y");
    setAllocatedCount(allocatedRows?.length);
    let unallocatedRows = rows?.filter((x: any) => x.isAllocated === "N");
    setUnallocatedCount(unallocatedRows?.length);
    let settledRows = rows?.filter(
      (x: any) => x.return_dtc_status === "Settled"
    );
    setSettledCount(settledRows?.length);
    let unsettledRows = rows?.filter(
      (x: any) => x.isAllocated === "Y" && x.return_dtc_status !== "Settled"
    );
    setUnsettledCount(unsettledRows?.length);
    let buyInRows = rows?.filter((x: any) => x.isBuyIn === "Y");
    setBuyInCount(buyInRows?.length);

    let fullyReturnedRows = rows?.filter((x: any) => x.isFullyReturned);
    setFullyReturnedCount(fullyReturnedRows?.length);
  };

  const setCusipAllocations = async (cusip: any) => {
    let accountId = window.localStorage.getItem("activeAccountCode");
    let rows = await getAllocationsList(accountId, cusip);
    if (_.isArray(rows)) {
      setInitialAllocations([...rows]);
    }
  };

  useEffect(() => {
    if (!_.isNull(selectedCusip)) {
      setCusipAllocations(selectedCusip);
      let row = initialLoanReturns.find((l) => l.cusip === selectedCusip);
      if (row?.ticker) {
        setSelectedTicker(row?.ticker);
      }
      if (row?.sec_id) setSelectedTickerCusip(row?.sec_id);
    } else {
      setCusipAllocations(null);
    }
  }, [selectedCusip]);

  useEffect(() => {
    getServiceHealthCheck();
  }, []);

  useEffect(() => {
    let rows = [...initialLoanReturns];
    if (extneralCallbackFilters && !_.isEmpty(rows)) {
      if (!_.isEmpty(initialLoanReturns)) {
        if (
          extneralCallbackFilters.isAllocatedFilterActive ||
          extneralCallbackFilters.isUnallocatedFilterActive
        ) {
          if (extneralCallbackFilters.isAllocatedFilterActive)
            rows = filterLoanRows(metricFilters.allocated, rows);
          else if (extneralCallbackFilters.isUnallocatedFilterActive)
            rows = filterLoanRows(metricFilters.unallocated, rows);
        }
        if (
          extneralCallbackFilters.isSettledFilterActive ||
          extneralCallbackFilters.isUnsettledFilterActive
        ) {
          if (extneralCallbackFilters.isSettledFilterActive)
            rows = filterLoanRows(metricFilters.settled, rows);
          else if (extneralCallbackFilters.isUnsettledFilterActive)
            rows = filterLoanRows(metricFilters.unsettled, rows);
        }
      }
    }
    setLoanReturns(rows);
  }, [extneralCallbackFilters, initialLoanReturns]);

  useEffect(() => {
    let rows = [...initialAllocations];
    if (extneralAllocationFilters && !_.isEmpty(rows)) {
      if (
        extneralAllocationFilters.isAllocatedFilterActive ||
        extneralAllocationFilters.isUnallocatedFilterActive
      ) {
        if (extneralAllocationFilters.isAllocatedFilterActive)
          rows = filterAllocationRows(metricFilters.allocated, rows);
        else if (extneralAllocationFilters.isUnallocatedFilterActive)
          rows = filterAllocationRows(metricFilters.unallocated, rows);
      }
      if (
        extneralAllocationFilters.isSettledFilterActive ||
        extneralAllocationFilters.isUnsettledFilterActive
      ) {
        if (extneralAllocationFilters.isSettledFilterActive)
          rows = filterAllocationRows(metricFilters.settled, rows);
        else if (extneralAllocationFilters.isUnsettledFilterActive)
          rows = filterAllocationRows(metricFilters.unsettled, rows);
      }
      if (extneralAllocationFilters.isBuyInFilterActive) {
        rows = filterAllocationRows(metricFilters.buyIn, rows);
      }
      if (extneralAllocationFilters?.isFullyReturnedFilterActive) {
        rows = filterAllocationRows(metricFilters.fullyReturned, rows);
      }
    }
    setAllocations(rows);
  }, [extneralAllocationFilters, initialAllocations]);

  const filterLoanRows = (filter: any, rows: any) => {
    switch (filter) {
      case metricFilters.allocated:
        return rows?.filter(
          (x: any) => x.cusipBasedAllocationPercentage >= 100
        );
      case metricFilters.unallocated:
        return rows?.filter((x: any) => x.cusipBasedAllocationPercentage < 100);
      case metricFilters.settled:
        return rows?.filter((x: any) => x.return_dtc_status === "Settled");
      case metricFilters.unsettled:
        return rows?.filter(
          (x: any) =>
            x.cusipBasedAllocationPercentage >= 100 &&
            x.return_dtc_status !== "Settled"
        );
    }
    return rows;
  };

  const filterAllocationRows = (filter: any, rows: any) => {
    switch (filter) {
      case metricFilters.allocated:
        return rows?.filter((x: any) => x.isAllocated === "Y");
      case metricFilters.unallocated:
        return rows?.filter((x: any) => x.isAllocated === "N");
      case metricFilters.settled:
        return rows?.filter((x: any) => x.return_dtc_status === "Settled");
      case metricFilters.unsettled:
        return rows?.filter(
          (x: any) => x.isAllocated === "Y" && x.return_dtc_status !== "Settled"
        );
      case metricFilters.buyIn:
        return rows?.filter((x: any) => x.isBuyIn === "Y");
      case metricFilters.fullyReturned:
        return rows?.filter((x: any) => !x.isFullyReturned);
    }
    return rows;
  };

  useEffect(() => {
    socketConsolidateClient.connect(
      {},
      function (frame: any) {
        socketConsolidateClient.subscribe(
          "/topic/consolidated_message",
          async function (result: any) {
            let resultJson = JSON.parse(result?.body);
            if (getEnv() !== envs.PROD) {
              console.log(
                `Data received from /topic/consolidated_message at ${moment()?.toDate()} - `,
                resultJson
              );
            }
            await onSocketMsgReceive(resultJson?.socketMssgmap);
          }
        );
      },
      {},
      () => {}
    );

    return () => {
      if (socketConsolidateClient?.connected) {
        socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
        socketConsolidateClient?.disconnect();
      }
    };
  }, []);

  const onSocketMsgReceive = async (msg: any) => {
    const returnList = _.get(msg, socketMsgType.RETURN);
    const contractList = _.get(msg, socketMsgType.CONTRACT_UPDATES_RETURN);
    const callbackList = _.get(msg, socketMsgType.CALLBACK);
    const dtcCallbackMatch = _.get(msg, socketMsgType.DTC_CALLBACK_MATCH);
    const dtcStatusList = _.get(msg, socketMsgType.MATCH_CONTRACT_ACTIVITY);

    try {
      if (_.isArray(callbackList) && !_.isEmpty(callbackList)) {
        let socketRows = [...callbackList]?.map((item: any) => {
          let con = item?.messageJson;
          return {
            ...con,
            createdDate: getTimeStamp(con.create_date),
            totalReturnQuantity: getTotalReturnQuantity(
              con.cusip,
              initialAllocations
            ),
            callbackCreatedDate: getTimeStamp(con.callback_create_date),
            callbackUpdatedDate: getTimeStamp(con.callback_updated_date),
            returnUpdatedDate: getTimeStamp(con.return_updated_date),
            allocationPercentage: getAllocationPercentage(
              con.cusip,
              initialAllocations,
              con.callback_quantity
            ),
            cusipBasedAllocationPercentage: getCusipAllocationPercentage(
              con.cusip,
              initialAllocations,
              initialLoanReturns
            ),
          };
        });

        if (_.isArray(socketRows) && !_.isEmpty(socketRows)) {
          setLoanReturns((previousRows: any) => {
            const currentRows = previousRows;
            const insertRows: any[] = [];
            socketRows?.forEach((loan) => {
              var index = currentRows?.findIndex(
                (l: any) => l?.callbacks_id === loan?.callbacks_id
              );
              if (index >= 0) {
                currentRows[index] = loan;
              } else {
                insertRows.push(loan);
              }
            });
            const uniqRows = _.uniqBy(insertRows, "callbacks_id");
            if (uniqRows && _.isArray(uniqRows) && uniqRows?.length > 0) {
              const ids = uniqRows?.map((c) => {
                return c?.id;
              });
              setInsertedLoanReturnRowIds(ids?.length > 0 ? [ids] : []);
            }

            setInsertedLoanReturnRows(
              uniqRows && uniqRows?.length > 0 ? uniqRows : []
            );

            return currentRows;
          });

          setInitialLoanReturns((previousRows: any) => {
            const currentRows = previousRows;

            socketRows?.forEach((loan) => {
              var index = currentRows?.findIndex(
                (l: any) => l?.callbacks_id === loan?.callbacks_id
              );
              if (index >= 0) {
                currentRows[index] = loan;
              } else {
                currentRows.push(loan);
              }
            });

            // let sortedRows = _.orderBy(
            //   currentRows,
            //   ["isRecall", "sec_id", "rate"],
            //   ["desc", "asc", "desc"]
            // );

            return currentRows;
          });
        }
      }

      if (_.isArray(returnList) && !_.isEmpty(returnList)) {
        let socketRows = [...returnList]?.map((item: any) => {
          let con = item?.messageJson;
          return {
            ...con,
            id: con.returns_id > 0 ? con.returns_id : con.contract_id,
            // id:
            //   (con.contract_id ? con.contract_id.toString() : "") +
            //   (con.bl ? con.bl.toString() : "") +
            //   (con.returns_id ? con.returns_id.toString() : ""),

            isBuyIn: con.is_buyin === null ? "null" : con.is_buyin,
            returnUpdatedDate: getTimeStamp(con.return_updated_date),
          };
        });

        setAllocations((previousRows: any) => {
          const currentRows = [...previousRows];
          const insertRows: any[] = [];
          socketRows?.forEach((loan) => {
            var index = currentRows?.findIndex(
              (l: any) => l?.returns_id === loan?.returns_id
            );
            var updateIndex = currentRows?.findIndex(
              (l: any) =>
                l?.contract_id === loan.contract_id &&
                l?.returns_id === 0 &&
                loan?.returns_id > 0 &&
                l?.isAllocated === "N"
            );
            if (index >= 0 || updateIndex >= 0) {
              const ind = index >= 0 ? index : updateIndex;
              currentRows[ind].borrow_amt = loan.borrow_amt;
              currentRows[ind].borrow_quantity = +loan.borrow_quantity;
              currentRows[ind].isAllocated = loan.isAllocated;
              currentRows[ind].processing_status = loan.processing_status;
              currentRows[ind].comments = loan.comments;
              currentRows[ind].return_quantity = loan.return_quantity;
              currentRows[ind].remain_qty = loan.remain_qty;
              currentRows[ind].returnUpdatedDate = loan.return_updated_date;
              currentRows[ind] = { ...loan };
            } else {
              insertRows.push(loan);
            }
          });
          const uniqRows = _.uniqBy(insertRows, "id");
          // if (uniqRows && _.isArray(uniqRows) && uniqRows?.length > 0) {
          //   const ids = uniqRows?.map((c) => {
          //     return c?.id;
          //   });
          //   setInsertedAllocationRowIds(ids?.length > 0 ? [ids] : []);
          // }

          setInsertedAllocationRows(
            uniqRows && uniqRows?.length > 0 ? uniqRows : []
          );
          return currentRows;
        });

        // setInitialAllocations((previousRows: any) => {
        //   const currentRows = [...previousRows];

        //   socketRows?.forEach((loan) => {
        //     var index = currentRows?.findIndex(
        //       (l: any) => l?.returns_id === loan?.returns_id
        //     );
        //     var updateIndex = currentRows?.findIndex(
        //       (l: any) =>
        //         l?.contract_id === loan.contract_id &&
        //         l?.returns_id === 0 &&
        //         loan?.returns_id > 0 &&
        //         l?.isAllocated === "N"
        //     );
        //     if (index >= 0 || updateIndex >= 0) {
        //       const ind = index >= 0 ? index : updateIndex;
        //       currentRows[ind] = { ...loan };
        //       currentRows[ind].borrow_amt = loan.borrow_amt;
        //       currentRows[ind].borrow_quantity = +loan.borrow_quantity;
        //       currentRows[ind].isAllocated = loan.isAllocated;
        //       currentRows[ind].processing_status = loan.processing_status;
        //       currentRows[ind].comments = loan.comments;
        //       currentRows[ind].return_quantity = loan.return_quantity;
        //       currentRows[ind].remain_qty = loan.remain_qty;
        //       currentRows[ind].returnUpdatedDate = loan.return_updated_date;
        //     }
        //     //   else{
        //     //   currentRows.push(loan)
        //     //  }
        //   });

        //   return currentRows;
        // });
      }

      if (_.isArray(contractList) && !_.isEmpty(contractList)) {
        let socketRows = [...contractList]?.map((item: any) => {
          let con = item?.messageJson;
          return {
            ...con,
            id: con.returns_id > 0 ? con.returns_id : con.contract_id,
            // id:
            //   (con.contract_id ? con.contract_id.toString() : "") +
            //   (con.bl ? con.bl.toString() : "") +
            //   (con.returns_id ? con.returns_id.toString() : ""),

            isBuyIn: con.is_buyin === null ? "null" : con.is_buyin,
            returnUpdatedDate: getTimeStamp(con.return_updated_date),
          };
        });

        setAllocations((previousRows: any) => {
          const currentRows = [...previousRows];
          // const insertRows: any[] = [];

          [...socketRows]?.forEach((loan) => {
            var index = currentRows?.findIndex((l: any) =>
              l?.returns_id && l?.returns_id > 0
                ? l?.returns_id === loan?.returns_id
                : l?.contract_id === loan?.contract_id
            );
            if (index >= 0) {
              currentRows[index].borrow_amt = loan.borrow_amt;
              currentRows[index].borrow_quantity = +loan.borrow_quantity;
              currentRows[index].isAllocated = loan.isAllocated;
              currentRows[index].processing_status = loan.processing_status;
              currentRows[index].comments = loan.comments;
              currentRows[index].rate = loan.rate;
              currentRows[index].isFullyReturned =loan?.borrow_quantity === 0
              currentRows[index] = { ...loan };
            }
            //  else {
            //   loan.isFullyReturned =loan?.borrow_quantity === 0
            //   insertRows.push(loan);
            // }
          });

          // const uniqRows = _.uniqBy(insertRows, "id");
          // if (uniqRows && _.isArray(uniqRows) && uniqRows?.length > 0) {
          //   const ids = uniqRows?.map((c) => {
          //     return c?.id;
          //   });
          //   setInsertedAllocationRowIds(ids?.length > 0 ? [ids] : []);
          // }

          // if (uniqRows && uniqRows?.length > 0)
          //   setInsertedAllocationRows(uniqRows);

          return currentRows;
        });

        setInitialAllocations((previousRows: any) => {
          const currentRows = [...previousRows];
          [...socketRows]?.forEach((loan) => {
            var index = currentRows?.findIndex((l: any) =>
              l?.returns_id > 0
                ? l?.returns_id === loan?.returns_id
                : l?.contract_id === loan?.contract_id
            );
            if (index >= 0) {
              currentRows[index].borrow_amt = loan.borrow_amt;
              currentRows[index].borrow_quantity = loan.borrow_quantity;
              currentRows[index].rate = loan.rate;
              currentRows[index].isAllocated = loan.isAllocated;
              currentRows[index].processing_status = loan.processing_status;
              currentRows[index].comments = loan.comments;
              currentRows[index].rate = loan.rate;
            }
          });

          return currentRows;
        });
      }
    } catch (error) {
      console.log("err", error);
    }
    if (_.isArray(dtcCallbackMatch) && !_.isEmpty(dtcCallbackMatch)) {
      let socketRows = [...dtcCallbackMatch]?.map((item: any) => {
        return { ...item, id: item?.callbacks_id };
      });

      await updateDTCStatusCallbacksGrid(socketRows);
    }

    if (_.isArray(dtcStatusList) && !_.isEmpty(dtcStatusList)) {
      let socketRows = [...dtcStatusList]?.map((item: any) => {
        return { ...item, id: item?.returns_id };
      });

      await updateDTCStatusAllocationsGrid(socketRows);
    }
  };

  const updateDTCStatusCallbacksGrid = async (trades: any) => {
    setLoanReturns((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.callbacks_id === trade?.callbacks_id
            );
            if (index >= 0) {
              currentRows[index].return_dtc_status = trade?.match_status;
              return currentRows;
            }
          });
        }
      }

      return previousRows;
    });

    setInitialLoanReturns((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.callbacks_id === trade?.callbacks_id
            );
            if (index >= 0) {
              currentRows[index].return_dtc_status = trade?.return_dtc_status;
              return currentRows;
            }
          });
        }
      }

      return previousRows;
    });
  };

  const updateDTCStatusAllocationsGrid = async (trades: any) => {
    setLoanReturns((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.callbacks_id === trade?.callbacks_id
            );
            if (index >= 0) {
              currentRows[index].return_dtc_status = trade?.return_dtc_status;
              return currentRows;
            }
          });
        }
      }

      return previousRows;
    });

    setInitialLoanReturns((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.callbacks_id === trade?.callbacks_id
            );
            if (index >= 0) {
              currentRows[index].return_dtc_status = trade?.return_dtc_status;
              return currentRows;
            }
          });
        }
      }

      return previousRows;
    });
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const handleContractReturnClose = () => {
    setSelectedRows([]);
    setIsDeselectAll(true);
    setTimeout(() => {
      refreshAccount();
    }, 1200);
    setContractReturnPopupOpen(false);
  };


const onReturn = () => {
  if (!selectedRows || selectedRows.length === 0) {
    setRowsToReturn([]);
    setIsAllocationsProcessing(false);
    return;
  }

  setIsAllocationsProcessing(true);

  const contractIdList = _.uniq(selectedRows.map((row: any) => row?.contract_id));

  if (contractIdList.length === 0) {
    setRowsToReturn([]);
    setIsAllocationsProcessing(false);
    return;
  }

  getAllocationsByContract(contractIdList)
    ?.then((res) => {
      if (!res || res.length === 0) {
        setRowsToReturn([]);
        setIsAllocationsProcessing(false);
        return;
      }

      const groupedRows = _.groupBy(res, "contract_id");
      const finalList: any[] = [];

      _.forIn(groupedRows, (allocations: any[]) => {
        if (Array.isArray(allocations) && allocations.length > 0) {
          const latestAllocation =
            _.maxBy(allocations, (x) => x.returns_id || 0) || allocations[allocations.length - 1];

          const allocatedList = allocations.filter((x: any) => x.isAllocated === "Y");
          const returnedQuantity = _.sumBy(allocatedList, "return_quantity");

          finalList.push({
            ...latestAllocation,
            returned_quantity: returnedQuantity,
            quantity: latestAllocation?.borrow_quantity,
            contract_type: latestAllocation?.bl,
            cusip: latestAllocation?.sec_id,
            id: latestAllocation.contract_id, // unique per contract
            contractPrice:
              latestAllocation?.borrow_amt &&
              latestAllocation?.borrow_quantity &&
              latestAllocation.borrow_quantity > 0
                ? parseFloat(
                    (latestAllocation.borrow_amt / latestAllocation.borrow_quantity).toString()
                  ).toFixed(2)
                : "",
          });
        }
      });

      setRowsToReturn(finalList);
      setContractReturnPopupOpen(true);
      setIsAllocationsProcessing(false);
    })
    .catch((err) => {
      console.log("error", err);
      setRowsToReturn([]);
      setIsAllocationsProcessing(false);
    });
};

  const getCardHeight = () => {
    const offsetHeight = document?.getElementById("rates-title")?.offsetHeight;
    const divHeight = _.isUndefined(offsetHeight) ? 2 : offsetHeight + 2;

    return "calc(100% - " + divHeight + "px)";
  };

  useEffect(() => {
    if (
      insertedAllocationRows &&
      _.isArray(insertedAllocationRows) &&
      !_.isEmpty(insertedAllocationRows)
    ) {
      setAllocations((previousRows: any) => {
        const rows = [...insertedAllocationRows, ...previousRows];

        return rows;
      });

      setInitialAllocations((previousRows: any) => {
        const rows = [...insertedAllocationRows, ...previousRows];

        return rows;
      });
    }
  }, [insertedAllocationRows]);

  useEffect(() => {
    if (
      insertedLoanReturnRows &&
      _.isArray(insertedLoanReturnRows) &&
      !_.isEmpty(insertedLoanReturnRows)
    ) {
      setLoanReturns((previousRows: any) => {
        const rows = [...insertedLoanReturnRows, ...previousRows];

        return rows;
      });

      setInitialLoanReturns((previousRows: any) => {
        const rows = [...insertedLoanReturnRows, ...previousRows];

        return rows;
      });
    }
  }, [insertedLoanReturnRows]);

  const getServiceHealthCheck = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["RETURNS-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`${messages.returnsServiceDown}`);
        setOpen(true);
      } else {
        refreshAccount();
      }
    });
  };

  const getAllocationsByContract = async (contractId: any) => {
    const accountId = window.localStorage.getItem("activeAccountCode");
    const request = {
      contract_id: [...contractId],
      account_id: accountId,
    };

    try {
      return await getReturnsByContract(request).then(
        async (allocationsRes: any) => {
          if (allocationsRes?.status === 200) {
            const contractList = await allocationsRes.json();

            return contractList;
          } else if (allocationsRes?.status === 401) {
            return [];
          } else {
            return [];
          }
        }
      );
    } catch (err) {
      return [];
    }
  };

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "#EAECEF",
          overflow: "hidden",
        }}
      >
        {isAllocationsProcessing && <SpinnerFullScreen></SpinnerFullScreen>}
        <div
          className="title-subHeaderTitle dtc-title py-2 my-1"
          style={{ paddingLeft: "0.5rem" }}
        >
          Callbacks / Returns
        </div>
        <Card style={{ height: getCardHeight() }}>
          <CardContent className="h-100 pt-0 px-0">
            <hr className="my-0 ps-3 pe-3 pb-0" style={{ width: "99.8%" }} />
            <div
              className="row kpi w-100 pb-0"
              style={{ backgroundColor: "#f0f8ff78" }}
            >
              <div className="col-3 d-flex align-items-center">
                <div className="globalfilterdiv globalSearch-globalFilter w-75 mt-0">
                  <input
                    type="search"
                    placeholder="Global search..."
                    id="filter-text-box"
                    onInput={onFilterTextChange}
                  />
                  <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
                </div>
              </div>

              <div className="col-6">
                <KPIComponent
                  ticker={selectedTicker}
                  cusip={selectedTickerCusip}
                ></KPIComponent>
              </div>
              <div className="col-3 d-flex  justify-content-end align-items-center pe-0">
                <div className="float-end d-flex align-items-center">
                  <button
                    type="button"
                    onClick={reset}
                    className="reset-btn d-flex btn reset-btn btn-primary align-self-center justify-content-center h-75 me-1"
                  >
                    Reset
                  </button>
                  <span
                    className="borrowExceldnld float-start"
                    onClick={onExcelExport}
                    title="Download Excel"
                  >
                    <img
                      src={excel}
                      alt=""
                      style={{
                        height: "1.8rem",
                        width: "1.8rem",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                  <span
                    onClick={refreshAccountObj}
                    title="Refresh Data"
                    className="refresh-dtc float-end"
                  >
                    <RefreshIcon
                      style={{
                        color: "#1E355E",
                        marginRight: "0.5rem",
                        height: "1.6rem",
                        width: "1.6rem",
                        cursor: "pointer",
                      }}
                    />
                    <span className="refreshsettimedateContract">
                      <span>Last updated on: </span>
                      <span style={{ whiteSpace: "nowrap" }}>
                        {lastRefresh}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="ps-1">
              <hr className="my-0 ps-3 pe-3" style={{ width: "99.8%" }} />
            </div>
            <div className="grids-div mt-0 mx-auto h-100 pb-3 px-0">
              <Split initialPrimarySize="40%">
                <div style={{ height: "100%" }}>
                  <LoanReturnsGrid
                    applyLoanMetricsFilters={setExtneralCallbackFilters}
                    settledCount={loanSettledCount}
                    isResetFilters={isResetFilters}
                    unsettledCount={loanUnsettledCount}
                    allocatedCount={loanAllocatedCount}
                    unallocatedCount={loanUnallocatedCount}
                    rowData={loanReturns}
                    height={33.6}
                    title="Loan Callbacks"
                    globalSearch={globalSearch}
                    type={constants.DtcOut}
                    getBtnRef={(gridRef: any) => {
                      setRefLoanReturns(gridRef);
                    }}
                    getGridApi={(gridApi: any) => {}}
                    onRowSelected={(ticker: any, cusip: number) => {
                      setSelectedCusip(cusip);
                      setSelectedTicker(ticker);
                      setSelectedTickerCusip(cusip);
                    }}
                    appliedFilterStateCallbackGrid={(filterState: any) => {
                      setAppliedFiltersCallbackGrid(filterState);
                    }}
                    filters={appliedFiltersCallbackGrid}
                    onDataLoaded={() => {
                      setIsCallbacksProcessing(false);
                    }}
                    insertRowId={insertedLoanReturnRowIds}
                  />
                </div>
                <div style={{ height: "100%" }}>
                  <AllocationsGrid
                    settledCount={settledCount}
                    unsettledCount={unsettledCount}
                    buyInCount={buyInCount}
                    isResetFilters={isResetFilters}
                    rowData={allocations}
                    applyAllocationMetricFilters={setExtneralAlocationFilters}
                    allocatedCount={allocatedCount}
                    unallocatedCount={unallocatedCount}
                    height={33.6}
                    onRowSelected={(ticker: any, cusip: any) => {
                      setSelectedTicker(ticker);
                      setSelectedTickerCusip(cusip);
                    }}
                    title="Borrow Allocations"
                    globalSearch={globalSearch}
                    type={constants.DtcOut}
                    getBtnRef={(gridRef: any) => {
                      setRefAllocations(gridRef);
                    }}
                    getGridApi={(gridApi: any) => {}}
                    appliedFilterStateAllocGrid={(filterState: any) => {
                      setAppliedFiltersAllocGrid(filterState);
                    }}
                    filters={appliedFiltersAllocGrid}
                    onReturn={onReturn}
                    isDeselectAll={isDeselectAll}
                    setSelectedRows={(rows: any) => {
                      setSelectedRows(rows);
                    }}
                    fullyReturnedCount={fullyReturnedCount}
                    insertRowId={insertedAllocationRowIds}
                  />
                </div>
              </Split>
            </div>
          </CardContent>
        </Card>

        <div>
          <Modal
            size="xl"
            centered
            show={isContractReturnPopupOpen}
            onHide={handleContractReturnClose}
            backdrop="static"
          >
            <Modal.Header
              style={{
                backgroundColor: "#6a7587",
                color: "#fff",
                height: "3rem",
              }}
              closeButton
            >
              <Modal.Title>Return Contract</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ContractReturn
                selectedRows={rowsToReturn}
                setDoShowFullScreenLoader={setDoShowFullScreenLoader}
                doShowFullScreenLoader={doShowFullScreenLoader}
                handleContractReturnClose={handleContractReturnClose}
                user={props?.user}
                type={"Returns"}
                updateGridCells={() => {}}
              />
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default withUser(LoanReturns);
